// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"620":"287ca5fa","684":"3bd65cc4"}[chunkId] + ".chunk.js";
};